import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../utils/Helper';

interface OwnProps {
  imgURL: string;
  alt: string;
  isImgRightSide: boolean;
  classname: string | null;
  maxWidth?: string;
}

const Container = styled.div`
  align-items: center;
  margin: 8rem 0rem;
  display: flex;
  ${media.tablet`flex-direction: column;margin: 3.2rem 0rem;`}
  &.img-right {
    ${media.tablet`flex-direction: column-reverse;`}
  }
`;
const ImgBox = styled.div`
  ${media.tablet`text-align: center;`}
`;
const ImgBase = styled.img`
  max-width: ${({ theme }) => theme.maxWidth};
  margin-right: 192px;
  ${media.tablet`max-width: none; width:100%; height:auto; `}
`;
const ImgRight = styled(ImgBase)`
  margin-left: 7.6rem;
  margin-right: 0px;
  ${media.tablet`margin-left: 0`}
`;
const ImgLeft = styled(ImgBase)`
  margin-right: 7.6rem;
  ${media.tablet`margin-right: 0`}
`;

class ImagePluTextBox extends Component<OwnProps> {
  render() {
    const { imgURL, alt, isImgRightSide, classname } = this.props;
    return isImgRightSide ? (
      <Container className={`img-right ${classname}`}>
        <div>{this.props.children}</div>
        <ImgBox>
          <ImgRight
            theme={{
              maxWidth: this.props.maxWidth ? this.props.maxWidth : '304px',
            }}
            src={imgURL}
            alt={alt}
            className="shadow"
            width=""
            height=""
          />
        </ImgBox>
      </Container>
    ) : (
      <Container className={`${classname}`}>
        <ImgBox>
          <ImgLeft
            theme={{
              maxWidth: this.props.maxWidth ? this.props.maxWidth : '304px',
            }}
            src={imgURL}
            alt={alt}
            className="shadow"
            width=""
            height=""
          />
        </ImgBox>
        <div>{this.props.children}</div>
      </Container>
    );
  }
}
export default ImagePluTextBox;
